import AttachmentDataProvider from 'owa-service/lib/contract/AttachmentDataProvider';
import AttachmentDataProviderItem from 'owa-service/lib/contract/AttachmentDataProviderItem';
import AttachmentDataProviderScope from 'owa-service/lib/contract/AttachmentDataProviderScope';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentItemsFilterBy from 'owa-service/lib/contract/AttachmentItemsFilterBy';
import AttachmentItemsPagingMetadata from 'owa-service/lib/contract/AttachmentItemsPagingMetadata';
import AttachmentItemsSort from 'owa-service/lib/contract/AttachmentItemsSort';
import FilePickerAction from './store/schema/FilePickerAction';
import FilePickerConfiguration from './store/schema/FilePickerConfiguration';
import FilePickerResult, { SelectedFilesSource } from './types/FilePickerResult';
import FilePickerUploadConfiguration from './store/schema/FilePickerUploadConfiguration';
import GetAttachmentDataProviderItemsResponse from 'owa-service/lib/contract/GetAttachmentDataProviderItemsResponse';
import getDefaultFileProvider from './actions/helpers/getDefaultFileProvider';
import GetFileProviderItemsResponse from './types/GetFileProviderItemsResponse';
import RemoveAttachmentDataProviderResponse from 'owa-service/lib/contract/RemoveAttachmentDataProviderResponse';
import RequestOriginType from 'owa-service/lib/contract/RequestOriginType';
import { ActionsPanelState } from './actionsPanel';
import { AddableFileProviderInfo } from 'owa-fileprovider-store';
import { ComponentClass } from 'react';
import { createLazyComponent, LazyImport, LazyModule, LazyModuleType } from 'owa-bundling';
import { FilePickerViewType } from './types/FilePickerViewSwitcher';
import { FileProviderViewState, FileSelectionFilter } from 'owa-fileprovider-store';
import {
    LocalComputerFilePickerProps,
    ILocalComputerFilePicker,
} from './components/LocalComputerFilePicker';
export { ComponentClass };
import './mutators/filePickerMutators';

import FilePickerUserConfiguration, {
    AttachOrSharePreference,
    FilePickerUserConfigurationProperty,
} from './store/schema/FilePickerUserConfiguration';
import FileProviderItemViewState, {
    FileProviderItemType,
} from './store/schema/FileProviderItemViewState';
import {
    FacebookDataProviderItemType,
    FacebookProviderScopeType,
    SizeLimitInKbToSuggestSharing,
} from './utils/filePickerConstants';

/* This package SHOULD contain minimal attachment related logic. It should NOT take any dependencies on the attachment package.
   It is supposed to be self contained and possibly reusable outside OWA for picking files from different providers */
const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "FilePicker", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded components
export const LocalComputerFilePicker = createLazyComponent<
    LocalComputerFilePickerProps,
    LazyModuleType<typeof lazyModule>,
    ILocalComputerFilePicker
>(lazyModule, m => m.LocalComputerFilePicker);

// Delay loaded imports
export const lazyFilePicker = new LazyImport(lazyModule, m => m.filePicker);
export const lazyActionsPanel = new LazyImport(lazyModule, m => m.actionsPanel);
export const lazyGetFileProviderItems = new LazyImport(lazyModule, m => m.getFileProviderItems);

export const lazyCreateFileProviderItemsViewState = new LazyImport(
    lazyModule,
    m => m.createFileProviderItemsViewState
);

export const lazyPreloadFilePicker = new LazyImport(lazyModule, m => m.preloadFilePicker);
export const lazyGetUserPreferredFilePickerAction = new LazyImport(
    lazyModule,
    m => m.getUserPreferredFilePickerAction
);

// Type - not delay loaded
export {
    ActionsPanelState,
    AddableFileProviderInfo,
    AttachOrSharePreference,
    AttachmentDataProvider,
    AttachmentDataProviderItem,
    AttachmentDataProviderScope,
    AttachmentDataProviderType,
    AttachmentItemsFilterBy,
    AttachmentItemsPagingMetadata,
    AttachmentItemsSort,
    FacebookDataProviderItemType,
    FacebookProviderScopeType,
    FilePickerAction,
    FilePickerResult,
    FilePickerUserConfiguration,
    FilePickerUserConfigurationProperty,
    FilePickerViewType,
    FileProviderItemType,
    FileProviderItemViewState,
    FileProviderViewState,
    GetAttachmentDataProviderItemsResponse,
    GetFileProviderItemsResponse,
    ILocalComputerFilePicker,
    RemoveAttachmentDataProviderResponse,
    RequestOriginType,
    SelectedFilesSource,
    SizeLimitInKbToSuggestSharing,
    getDefaultFileProvider,
    LocalComputerFilePickerProps,
    FilePickerUploadConfiguration,
    FilePickerConfiguration,
};

// Schema - not delay loaded
export { FileSelectionFilter };
